export interface TopicGroup {
  name: string;
  movieIds: string[];
}

export interface Topic {
  id: string;
  title: string;
  cover: string;
  intro: string;
  reason: string;
  review: string;
  groups: TopicGroup[];
}

export const topics: Topic[] = [
  {
    id: 'deep-night-suspense',
    title: '深夜悬疑特辑：一口气追完的高能神作',
    cover:
      'https://readdy.ai/api/search-image?query=Atmospheric%20suspense%20collection%20banner%20artwork%20of%20a%20moody%20rainy%20city%20at%20night%20with%20glowing%20streetlights%20and%20long%20shadows%2C%20deep%20navy%20blue%20with%20warm%20amber%20highlights%2C%20stylized%20cinematic%20illustration%2C%20no%20text%2C%20highly%20detailed%20wide%20composition&width=1200&height=700&seq=topic-cover-01&orientation=landscape',
    intro:
      '专为悬疑爱好者打造的深夜片单，收录节奏紧凑、反转密集的口碑之作，让你在深夜里欲罢不能。',
    reason: '从冷峻的犯罪推理到烧脑的心理博弈，每一部都经得起反复推敲，是深夜追剧的绝佳选择。',
    review: '“看完《长夜将尽》直接熬到天亮，剧情紧凑得根本舍不得快进。”—— 用户 @追剧的小鱼',
    groups: [
      { name: '冷峻犯罪推理', movieIds: ['chang-ye-jiang-jin', 'wu-du-yi-yun', 'lan-se-bian-jing'] },
      { name: '都市心理迷局', movieIds: ['wu-sheng-zhi-cheng', 'an-yong', 'du-shi-bian-yuan'] },
    ],
  },
  {
    id: 'healing-weekend',
    title: '周末治愈片单：慢下来，好好生活',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20cozy%20collection%20banner%20artwork%20of%20a%20sunlit%20living%20room%20with%20plants%20tea%20and%20soft%20blankets%2C%20warm%20cream%20amber%20and%20gentle%20green%20tones%2C%20stylized%20watercolor%20illustration%2C%20peaceful%20tender%20mood%2C%20no%20text%2C%20highly%20detailed%20wide%20composition&width=1200&height=700&seq=topic-cover-02&orientation=landscape',
    intro:
      '把节奏调慢一点，给自己一个温柔的周末。这里有烟火气十足的生活流作品，也有治愈人心的温柔故事。',
    reason: '没有惊心动魄的冲突，只有普通人的三餐四季与小确幸，看完会让人重新爱上生活。',
    review: '“《烟火人间》太治愈了，每一集都像深夜里一碗热乎乎的面。”—— 用户 @小满_',
    groups: [
      { name: '烟火日常', movieIds: ['yan-huo-ren-jian', 'chu-fang-qi-yu-ji', 'huan-qiu-xun-wei-ji'] },
      { name: '温柔时光', movieIds: ['shi-guang-xin-xiang', 'chunri-chichi', 'gui-tu-lie-che'] },
    ],
  },
  {
    id: 'epic-scifi',
    title: '史诗科幻专场：把想象力推向宇宙尽头',
    cover:
      'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20collection%20banner%20artwork%20of%20distant%20planets%20spaceships%20and%20a%20swirling%20nebula%20in%20deep%20space%2C%20deep%20indigo%20blue%20with%20vivid%20orange%20and%20cyan%20glow%2C%20stylized%20illustration%2C%20vast%20majestic%20mood%2C%20no%20text%2C%20highly%20detailed%20wide%20composition&width=1200&height=700&seq=topic-cover-03&orientation=landscape',
    intro:
      '从星际远征到深海秘境，从荒漠星球到未来都市，这组片单带你领略人类想象力的极致边界。',
    reason: '顶级的工业视效配合扎实的世界观设定，是硬核科幻迷不能错过的一份清单。',
    review: '“《沙丘之外》的沙漠美学太震撼了，大银幕级别的震撼感，在家看也完全够味。”—— 用户 @星际漫游者',
    groups: [
      { name: '星际远征', movieIds: ['xing-hai-yuan-zheng', 'sha-qiu-zhi-wai', 'shen-hai-mi-hang'] },
      { name: '未知边境', movieIds: ['ni-guang-er-xing', 'huang-ye-gu-lang', 'shan-hai-zhu-guang'] },
    ],
  },
  {
    id: 'family-time',
    title: '全家一起看：适合周末聚会的高分作品',
    cover:
      'https://readdy.ai/api/search-image?query=Family%20friendly%20collection%20banner%20artwork%20of%20a%20comfortable%20living%20room%20with%20a%20warm%20lamp%20and%20popcorn%20on%20a%20sofa%2C%20warm%20amber%20and%20soft%20blue%20evening%20tones%2C%20stylized%20illustration%2C%20welcoming%20mood%2C%20no%20text%2C%20highly%20detailed%20wide%20composition&width=1200&height=700&seq=topic-cover-04&orientation=landscape',
    intro:
      '周末和家人围坐一起，看一部老少咸宜的好作品。这组片单兼顾热血、温情与欢乐，全家都能看得开心。',
    reason: '内容健康积极、看点丰富，既有热血竞技，也有温暖亲情，是家庭聚会的理想选择。',
    review: '“《逆光而行》和孩子一起看的，全程热血，结尾我们俩都哭了。”—— 用户 @周末不加班',
    groups: [
      { name: '热血励志', movieIds: ['ni-guang-er-xing', 'ji-xian-tiao-zhan-ying', 'nao-li-feng-bao'] },
      { name: '温情合家欢', movieIds: ['yan-huo-ren-jian', 'gui-tu-lie-che', 'sheng-dong-ren-xin'] },
    ],
  },
];